import { Button, Form, Input, message, Popconfirm, Select, Table } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import { isMobile } from "../../extensions/design";
import { dictsGetUsers, dictsDictionary2Options, userOptionsWithPosition } from "../../extensions/dicts";
import { getTableColumn } from "../../extensions/helper";
import { fmtDate } from "../../extensions/utils";

const VisitCntPacketItem = ({ itemMain, onClose, visitId, itemDefault, finish, defaultUserId, clientId }) => {
  const [form] = Form.useForm();
  const [item, setItem] = useState({visitId, saleId: itemMain?.saleId, saleProductId: itemMain?.id, qty: 1, userId: defaultUserId, ...itemDefault });
  const [executorUsers, setExecutorUsers] = useState([]);
  const [productVid, setProductVid] = useState(itemMain?.productVid ?? itemDefault?.productVid ?? 0);
  const [loading, setLoading] = useState(false);
  const [preferredUserId, setPreferredUserId] = useState(itemDefault?.userId ?? defaultUserId ?? item.userId ?? null);
  // История списаний по строке состава продажи (вкладка "Пакеты")
  const [usageItems, setUsageItems] = useState([]);
  const [usageLoading, setUsageLoading] = useState(false);

  // Загрузка истории списаний по конкретной услуге пакета
  const getUsageData = () => {
    if (!itemMain?.id) return;
    setUsageLoading(true);
    serverFetch(`sale/UseListBySaleProduct/${itemMain.id}`)
      .then(data => {
        setUsageItems(data ?? []);
        setUsageLoading(false);
      })
      .catch(e => {
        setUsageLoading(false);
        message.error(e.userMessage);
      });
  };

  useEffect(getUsageData, [itemMain?.id]);

  useEffect(() => {
    if (preferredUserId != null) return;
    if (!clientId) return;
    serverFetch(`client/${clientId}`)
      .then(data => {
        if (data?.userId != null) {
          setPreferredUserId(data.userId);
        }
      })
      .catch(() => {});
  }, [clientId, preferredUserId]);

  const loadExecutorUsers = (productId, vid) => {
    if ((vid === 1 || vid === 2 || vid === 3) && productId) {
      serverFetch("User/ProductUsersAsUsers/" + productId)
        .then(data => {
          if (data && data.length > 0) {
            const users = dictsDictionary2Options(data);
          if (preferredUserId != null && !users.some(u => u.value === preferredUserId)) {
              serverFetch("User/" + preferredUserId)
                .then(u => {
                  if (u && u.id != null) {
                     setExecutorUsers([{ ...u, value: u.id, label: u.name, disabled: true }, ...users]);
                  } else {
                    setExecutorUsers(users);
                  }
                })
                .catch(e => message.error(e.userMessage));
              return;
            }
            setExecutorUsers(users);
          } else {
            dictsGetUsers(setExecutorUsers, { activeOnly: true });
          }
        })
        .catch(e => message.error(e.userMessage));
    } else {
      dictsGetUsers(setExecutorUsers, { activeOnly: true });
    }
  };

  useEffect(() => { form.setFieldsValue(item) }, []);

  useEffect(() => {
    if (itemDefault?.id) return;
    if (defaultUserId == null) return;
    if (item.userId === defaultUserId) return;
    const next = { ...item, userId: defaultUserId };
    setItem(next);
    form.setFieldsValue({ userId: defaultUserId });
  }, [defaultUserId]);

  useEffect(() => {
    if (itemDefault?.id) return;
    if (preferredUserId == null) return;
    if (item.userId === preferredUserId) return;
    const next = { ...item, userId: preferredUserId };
    setItem(next);
    form.setFieldsValue({ userId: preferredUserId });
  }, [preferredUserId]);


  useEffect(() => {
    // productId/productVid могут прийти либо из itemMain (вкладка "Пакеты",
    // там это saleProduct), либо из itemDefault (вкладка "Продажи", там это SaleUse).
    const productId = itemMain?.productId ?? itemDefault?.productId;
    const vid = itemMain?.productVid ?? itemDefault?.productVid ?? 0;

    if (productId) {
      serverFetch(`product/${productId}`)
        .then(data => {
          setProductVid(data.vid);
          loadExecutorUsers(productId, data.vid);
        })
        .catch(e => {
          message.error(e.userMessage);
        });
    } else {
      setProductVid(vid);
      loadExecutorUsers(productId, vid);
    }
  }, [itemMain?.productId, itemDefault?.productId, itemDefault?.productVid, defaultUserId, preferredUserId]);

  const onValuesChange = value => setItem({...item, ...value});

  const isSelectedUserDisabled = executorUsers.some(u => u.value === item.userId && u.disabled);

  // Колонки истории списаний (как в карточке клиента, вкладка "Пакеты")
  const usageColumns = [
    getTableColumn("useDate", "Дата", { type: "date", width: 25, formatFn: fmtDate }),
    getTableColumn("visitId", "Визит", { type: "number", width: 25 }),
    getTableColumn("userName", "Исполнитель"),
    getTableColumn("qty", "Количество", { type: "number", width: 25 }),
  ];

  // История списаний по услуге пакета
  const divUsageHistory = itemMain?.id ? (
    <Table
      dataSource={usageItems}
      loading={usageLoading}
      columns={usageColumns}
      rowKey="id"
      size="small"
      className="table-detail"
      pagination={false}
      style={{ marginTop: 12 }}
    />
  ) : null;

  const onSave = () => {
    setLoading(true);
    serverFetch("sale/use", { method: item.id ? "PUT" : "POST", bodyData: item})
      .then(() => {
        getUsageData();
        onClose(true);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  const onDelete = () => {
    if (!window.confirm("Удалить?")) return;
    setLoading(true);
    serverFetch(`sale/use/${item.id}`, { method: "DELETE"})
      .then(() => {
        getUsageData();
        onClose(true);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  return !isMobile ?
  <div>
    <Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 4 }} wrapperCol={{ span: 20 }} colon={false} disabled={!item?.saleId || !!finish}>
        <Form.Item label="Количество" name="qty" wrapperCol={{span: 3}}><Input /></Form.Item>
        <Form.Item label="Исполнитель" name="userId" wrapperCol={{span: 16}}>
          <Select options={userOptionsWithPosition(executorUsers)} optionLabelProp="title" disabled={(productVid === 0 || productVid === 4) || !!finish} />
        </Form.Item>
        <Form.Item label=" ">
          <div className="main-content">
            <Button onClick={onDelete} disabled={loading || !item.id || !!finish}>Удалить</Button>
            {isSelectedUserDisabled ? (
              <Popconfirm title="Подтверждение" description="Сотрудник не является исполнителем услуги, продолжить?" onConfirm={onSave}>
                <Button disabled={loading || !item.qty || !item.userId || !!finish}>Списать</Button>
              </Popconfirm>
            ) : (
              <Button disabled={loading || !item.qty || !item.userId || !!finish} onClick={onSave}>Списать</Button>
            )}
            <Button onClick={() => onClose(false)} disabled={loading || !!finish}>Отмена</Button>
          </div>
        </Form.Item>
      </Form>
      {divUsageHistory}
  </div> : <>
    <Form form={form} layout="inline" colon={false} labelCol={{ span: 2 }} onValuesChange={onValuesChange} className="client-subitem-content" disabled={!item?.saleId || !!finish}>
      <Form.Item className="records-form-item-mobile" label="Кол-во" name="qty">
        <Input type="number" />
      </Form.Item>
      <Form.Item className="record-form-item-with-margin-top-mobile" label="Исполн." name="userId" >
        <Select className="records-form-item-mobile" options={userOptionsWithPosition(executorUsers)} optionLabelProp="title" disabled={(productVid === 0 || productVid === 4) || !!finish} />
      </Form.Item>
    </Form>
    <div className="visit-item-card-name-debt" style={{marginBottom: 2, marginTop: 4}}>
      {isSelectedUserDisabled ? (
        <Popconfirm title="Подтверждение" description="Сотрудник не является исполнителем услуги, продолжить?" onConfirm={onSave}>
          <Button style={{marginRight: 8}} className="visit-body-mobile-btn" disabled={loading || !item.qty || !item.userId || !!finish}>Списать</Button>
        </Popconfirm>
      ) : (
        <Button style={{marginRight: 8}} className="visit-body-mobile-btn" disabled={loading || !item.qty || !item.userId || !!finish} onClick={onSave}>Списать</Button>
      )}
      <Button style={{marginRight: 8}} className="visit-body-mobile-btn" onClick={onDelete} disabled={loading || !item.id || !!finish}>Удалить</Button>
      <Button className="visit-body-mobile-btn" onClick={() => onClose(false)} disabled={loading || !!finish}>Отмена</Button>
    </div>
    {divUsageHistory}
  </>
}

export default VisitCntPacketItem;